export default {
  QUESTIONS_REQUESTED: 'QUESTIONS_REQUESTED',
  QUESTIONS_REQUEST_SUCCEEDED: 'QUESTIONS_REQUEST_SUCCEEDED',
  QUESTIONS_REQUEST_FAILED: 'QUESTIONS_REQUEST_SUCCEEDED',
}